import React, { useEffect, useRef, useState } from 'react';
import './AnimatedSVG.css';

/**
 * AnimatedSVG - Component for displaying SVGs with CSS animations
 * Supports various animation types like float, pulse, bounce, etc.
 */
function AnimatedSVG({ 
  src, 
  alt = '', 
  animation = 'none',
  duration = 2,
  delay = 0,
  size = 'auto',
  className = '',
  onClick,
  style = {}
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  // Animation class mapping
  const animationClasses = {
    none: '',
    float: 'animated-svg-float',
    pulse: 'animated-svg-pulse',
    bounce: 'animated-svg-bounce',
    spin: 'animated-svg-spin',
    shake: 'animated-svg-shake',
    fadeIn: 'animated-svg-fade-in',
    slideUp: 'animated-svg-slide-up',
    slideIn: 'animated-svg-slide-in',
    glow: 'animated-svg-glow',
    swing: 'animated-svg-swing'
  };

  // Size class mapping
  const sizeClasses = {
    small: 'animated-svg-small',
    medium: 'animated-svg-medium',
    large: 'animated-svg-large',
    auto: ''
  };

  const animationClass = animationClasses[animation] || '';
  const sizeClass = sizeClasses[size] || '';

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const combinedStyle = {
    ...style,
    animationDuration: `${duration}s`,
    animationDelay: `${delay}s`
  };

  // Determine the full path
  const fullSrc = src?.startsWith('/') || src?.startsWith('http') 
    ? src 
    : `/assets/media/${src}`;

  return (
    <div 
      className={`animated-svg-container ${sizeClass} ${className} ${isLoaded ? 'loaded' : ''}`}
      onClick={onClick}
    >
      <img
        ref={imgRef}
        src={fullSrc}
        alt={alt}
        className={`animated-svg ${animationClass}`}
        style={combinedStyle}
        onLoad={handleLoad}
        onError={(e) => {
          console.warn(`Failed to load SVG: ${fullSrc}`);
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
}

export default AnimatedSVG;